import { Link } from "react-router-dom";
import { Sparkles, Phone } from "lucide-react";
import BannerSlot from "./BannerSlot";

const COL = [
  {
    title: "Services",
    links: [
      ["Motorhome Removal", "/service/motorhome-removal"],
      ["RV Disposal", "/service/rv-disposal"],
      ["Camper Removal", "/service/camper-removal"],
      ["Boat Removal", "/service/boat-removal"],
      ["Semi-Trailer Removal", "/service/semi-trailer-removal"],
      ["Bus & Prevost Removal", "/service/bus-prevost-removal"],
      ["Airplane Disposal", "/service/airplane-removal"],
      ["Helicopter Removal", "/service/helicopter-removal"],
      ["Real Property Removal", "/service/real-property-removal"],
      ["Squatter Removal", "/service/squatter-removal"],
    ]
  },
  {
    title: "Programs",
    links: [
      ["Power Sales Team ($250K+ · 22%)", "/join/sales-team"],
      ["Preferred Haulers", "/join/haulers"],
      ["Marketing Affiliates", "/join/affiliates"],
      ["Link Sharing", "/join/link-sharing"],
      ["Large Jobs (100+ units / $250k+)", "/large-jobs"],
      ["Consulting", "/consulting"],
    ]
  },
  {
    title: "Network",
    links: [
      ["The Exchange", "/exchange"],
      ["Closed Deals Wall", "/exchange/closed-deals"],
      ["AvailableMe Social", "/availableme"],
      ["Available Defenders", "/defenders"],
      ["Motion of the Week", "/defenders/motions"],
      ["Member Directory", "/exchange/members"],
      ["Honor Pay", "/exchange/honor"],
      ["30,000+ Cities", "/cities"],
      ["Translation Hub", "/translate"],
      ["Radical Intel", "/intel"],
      ["Developers", "/developers"],
      ["News", "/news"],
    ]
  }
];

export default function Footer() {
  return (
    <footer className="bg-[#0b1020] text-white mt-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <BannerSlot placement="footer" />
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 bg-[#f43f5e] rounded-2xl flex items-center justify-center shadow-[3px_3px_0_#fef3c7]">
                <Sparkles className="w-5 h-5" strokeWidth={2.5} />
              </div>
              <div className="display-black text-[18px] text-white">Available<span className="text-[#f43f5e]">.</span></div>
            </div>
            <p className="text-sm text-white/70 leading-relaxed">
              The friendly heavyweight of disposal. Bonded carriers, 30,000+ cities, USA + Canada. Anything in the way — we haul it off.
            </p>
            <a href="tel:9184073395" className="mt-6 inline-flex items-center gap-2 text-[#fde4b6] hover:text-white transition-colors text-sm font-semibold">
              <Phone className="w-4 h-4" /> 918-407-3395 · 24/7
            </a>
          </div>

          {COL.map(c => (
            <div key={c.title}>
              <div className="text-[11.5px] text-[#fde4b6] font-semibold mb-4 uppercase tracking-wider">{c.title}</div>
              <ul className="space-y-2.5">
                {c.links.map(([label, to]) => (
                  <li key={to}>
                    <Link to={to} className="text-[13.5px] text-white/85 hover:text-[#f43f5e] transition-colors" data-testid={`footer-${to.replaceAll("/", "-")}`}>
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
            <div className="text-[12px] text-white/55">
              © 2026 Available Junk Removal LLC · Independent · Bonded · Owner-Operated
            </div>
            <div className="text-[12px] text-white/55">
              Dispatch · 918-407-3395 · North America
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
